import { render, staticRenderFns } from "./License.vue?vue&type=template&id=5631dac9&scoped=true&"
import script from "./License.vue?vue&type=script&lang=js&"
export * from "./License.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=5631dac9&prod&lang=less&scoped=true&"
import style1 from "../assets/v2/css/trans/index.less?vue&type=style&index=1&id=5631dac9&prod&lang=less&scoped=true&"
import style2 from "./License.vue?vue&type=style&index=2&id=5631dac9&prod&lang=less&"
import style3 from "./License.vue?vue&type=style&index=3&id=5631dac9&prod&lang=less&scoped=true&"
import style4 from "./License.vue?vue&type=style&index=4&id=5631dac9&prod&lang=less&scoped=true&"
import style5 from "./License.vue?vue&type=style&index=5&id=5631dac9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631dac9",
  null
  
)

export default component.exports